import ImageDisplayAndDelete from '../ImagesGeneral/ImagesDisplayAndDelete'
import ImageUpload from '../ImagesGeneral/ImageUpload'
import ErrorBox from '../../../general/ErrorBox'

const ImageObjDisplayAndUploadComponent = ({
    field,
    form,
    hasImage, 
    image,
    isDisabled,
    isUploading, 
    errorMessages,
    textUnderDropzone,
    onUploadStart, 
    onUploadEndSuccess, 
    onUploadEndError,
    onDeleteStart,
    onResetErrorMessages,
    imagePosition,
    imagePositionX
}) => (
    
    <div className="image-display-upload">
        {isUploading && <div className='overlay'>
            <div className="spinner"></div>
        </div>}

        {hasImage ? (
            <ImageDisplayAndDelete
                isDisabled={isDisabled}
                field={field}
                image={image}
                imagePosition={imagePosition}
                imagePositionX={imagePositionX}
                onDeleteImage={onDeleteStart}
            />
        ) : (

            <ImageUpload
                isDisabled={isDisabled}
                isUploading={isUploading}
                textUnderDropzone={textUnderDropzone}
                onUploadStart={onUploadStart}
                onUploadEndSuccess={onUploadEndSuccess}
                onUploadEndError={onUploadEndError}
                onResetErrorMessages={onResetErrorMessages}
            />
        )}

        <ErrorBox 
            messages={errorMessages}
        />
    </div>
)

export default ImageObjDisplayAndUploadComponent